// @flow

// Types
import type {
  Token,
} from '../../types'

import type {
  Post,
} from 'fc-fetch/types'

// Constants
import {
  URL_TOKEN_LOGIN,
} from '../constants'

import {
  receiveToken,
} from '../actions'

// Effect Managers
import { call, put } from 'redux-saga/effects'

// Utils
import decodeBadResponse from 'fc-decoders/src/badResponse'

// Local Types
type AuthenticateArgs = {
  username: string,
  password: string,
  __post: Post,
}

type Return = {
  token: ?Token,
  errors: Array<{ [string]: string }>,
}

// Exports
export default function *authenticate ({username, password, __post}: AuthenticateArgs): Generator<*, Return, *> {
  // Send authentication credentials to the server

  let token: ?Token = null

  try {
    const response: Response = yield call(__post, {
      path: URL_TOKEN_LOGIN,
      body: { username, password },
      excludeToken: true,
    })

    const json = yield call([response, response.json])

    if (response.status >= 200 && response.status < 300) {
      token = json.token
    } else {
      return {
        token: null,
        errors: decodeBadResponse(json),
      }
    }
  } catch (error) {
    console.error(error)
  }

  if (token) {
    // Dispatch the action that will store the token and username in state
    yield put(receiveToken({
      user: username,
      token,
    }))

    return { token, errors: [] }
  }

  return { token: null, errors: [{error: 'error.unkown'}] }
}
